import React from 'react';
import { PackageTypes, PackageTypeWords } from '~/lib/PackageHelpers';
import PackagePageTemplate from '~/components/packages/PackagePageTemplate';

const PackagesIndexPage = ({}) => {
    return (
        <PackagePageTemplate
            type={PackageTypes.PACKAGE}
            singular={PackageTypeWords[PackageTypes.PACKAGE].singular}
            plural={PackageTypeWords[PackageTypes.PACKAGE].plural}
            introText="Packages allow clients to pay for multiple appointments up front."
            editPathBase="/packages"
        />
    );
};

export default PackagesIndexPage;
